/**
 * Phase 23 — NO_KV_BLOB Laufzeit-Flag (Env + persistierte Meta, Dev ohne Neustart).
 */

import { kvGet, kvSet } from './kvAccess';

export const PHASE23_META_KEY = 'Elkheir:v1:meta:storage_phase23_v1';

function readMeta() {
  try {
    const raw = kvGet(PHASE23_META_KEY);
    if (raw && typeof raw === 'object') return raw;
    if (typeof raw === 'string' && raw.trim()) {
      return JSON.parse(raw);
    }
  } catch {
    /* ignore */
  }
  return null;
}

function envNoKvBlobEnabled() {
  const v = process.env.REACT_APP_ENTITY_STORE_NO_KV_BLOB;
  return v === 'true' || v === '1';
}

/** Env oder persistiertes Meta-Flag. */
export function isPhase23NoKvBlobRuntimeEnabled() {
  if (envNoKvBlobEnabled()) return true;
  const meta = readMeta();
  return meta?.noKvBlob === true;
}

/**
 * DevTools: NO_KV_BLOB ohne Dev-Server-Neustart aktivieren.
 * @param {boolean} enabled
 */
export function setPhase23NoKvBlobRuntime(enabled) {
  const payload = {
    noKvBlob: enabled === true,
    updatedAt: new Date().toISOString()
  };
  kvSet(PHASE23_META_KEY, payload);
  return { ok: true, ...payload, env: envNoKvBlobEnabled() };
}

export function getPhase23Status() {
  const meta = readMeta();
  return {
    envNoKvBlob: envNoKvBlobEnabled(),
    runtimeNoKvBlob: isPhase23NoKvBlobRuntimeEnabled(),
    meta
  };
}
